import React from 'react';

import { SearchStats, useHeadlessResults } from '@uncinc/react-searchkit';

import './style.scss';

const SearchAllContentStats = () => {
  const { infiniteHits } = useHeadlessResults();

  if (infiniteHits.length === 0) {
    return null;
  }

  return (
    <SearchStats className="SearchAllContent__Stats" />
  );
};

export default SearchAllContentStats;
